import Rete from "rete";
import { DateTimeSocket } from "../../../Utils/CommonSockets.js";
import { StringControl } from "../../rete-controls/StringControl.js"


export default class DateTimeComponent extends Rete.Component {
  constructor() {
    super("Date Time"); // name
    this._categories = ["Interval Nodes"];
  }

  builder(node) {
    let out1 = new Rete.Output("out1", "Now", DateTimeSocket);
    //let numControl1 = new StringControl(this.editor, "display1", true);

    return node
      .addOutput(out1);
      //.addControl(numControl1)
  }

  worker(node, inputs, outputs) {
    let now = new Date(Date.now());
    // this.editor.nodes
    //     .find(n => n.id == node.id)
    //     .controls.get("display1")
    //     .setValue(now.toUTCString());

      outputs["out1"]  = now;     
    
  }
}

//ReteComponentStore.add(new NumberAdderComponent());